import $ from 'jquery'
import './calculator'
import './menu'
import './carousel'
import './popups'
import './jquery.nselect.min'

let headerElement = document.getElementsByTagName('header')
let about = document.getElementById('about-us')
let menu = $('#menu');
let burger = document.getElementById('burger-button')
let body = document.getElementsByTagName('body')
let showHeader = true

window.addEventListener('scroll', function (e) {
    if (window.pageYOffset !== 0) {
        headerElement[0].classList.add('after-scroll')
    } else {
        headerElement[0].classList.remove('after-scroll')
    }
});

$(window).on('mousewheel', function (event) {
    if(window.innerHeight < body[0].clientHeight) {
        if (event.originalEvent.deltaY > 0) {
            headerElement[0].style.marginTop = -headerElement[0].clientHeight + 'px'
        } else if (showHeader) {
            headerElement[0].style.marginTop = 0
        }
    }
})

$('.profile-header').click(function () {
    if ($(this).parent().attr("class").split(' ').includes('open')) {
        $(this).parent().removeClass('open')
    } else {
        $('.profile-item').removeClass('open')
        $(this).parent().addClass('open')
    }
})

let video = $("#videoContainer")

$('.introVid').click(function () {
    headerElement[0].style.marginTop = -headerElement[0].clientHeight + 'px'
    video.addClass('open')
    autoPlayVideo('r3fE6FQT82s');
});

function autoPlayVideo() {
    let videoLink = video.attr('data-youtube')
    if (window.innerWidth > 1024) {
        video.html('<iframe id="youtube" width="100%" height="100%" src="' + videoLink + '?showinfo=0&controls=0&autoplay=1&loop=1&rel=0&wmode=transparent" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen wmode="Opaque"></iframe>');
    } else {
        video.html('<iframe id="youtube" width="100%" height="80%" src="' + videoLink + '?showinfo=0&controls=0&autoplay=1&loop=1&rel=0&wmode=transparent" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen wmode="Opaque"></iframe>');
    }
}

video.click(function () {
    $("#youtube").remove()
    video.removeClass('open')
})

// $('.nselect').nSelect();

